// Mock data for previewing the UI without a backend

export const mockEvents = [
  {
    _id: '1',
    title: 'Neon Nights: Techno Underground',
    slug: 'neon-nights-techno-underground',
    description: 'Experience the ultimate techno journey in London\'s most iconic underground venue. Featuring world-class DJs and an immersive light show that will transport you to another dimension.\n\nExpect heavy bass, driving beats, and an atmosphere like no other. This is techno at its finest.',
    status: 'published',
    featured: true,
    venue: {
      name: 'The Warehouse',
      address: '123 Industrial Road',
      city: 'London',
      country: 'UK',
      capacity: 1500
    },
    dates: [{ start: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(), end: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000 + 6 * 60 * 60 * 1000).toISOString() }],
    ageRestriction: 18,
    lineup: ['Charlotte de Witte', 'Amelie Lens', 'FJAAK', 'Local Support'],
    categories: ['techno', 'rave'],
    dressCode: 'Dark colors preferred',
    imageUrl: 'https://images.unsplash.com/photo-1574391884720-bbc3740c59d1?w=800',
    ticketTypes: [
      { _id: 't1', name: 'Early Bird', price: 25, quantity: 200, sold: 180, maxPerOrder: 4, description: 'Limited availability' },
      { _id: 't2', name: 'General Admission', price: 35, quantity: 800, sold: 450, maxPerOrder: 6 },
      { _id: 't3', name: 'VIP', price: 75, quantity: 100, sold: 30, maxPerOrder: 4, description: 'Includes fast-track entry & drink' }
    ],
    lowestPrice: 25,
    analytics: { views: 4500, addToCart: 890 }
  },
  {
    _id: '2',
    title: 'Summer Sunset Sessions',
    slug: 'summer-sunset-sessions',
    description: 'Join us for an unforgettable rooftop party with stunning city views, house music, and summer vibes. Perfect for those who love to dance under the stars.',
    status: 'published',
    featured: true,
    venue: {
      name: 'Skyline Rooftop',
      address: '45 High Street',
      city: 'Manchester',
      country: 'UK',
      capacity: 500
    },
    dates: [{ start: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString() }],
    ageRestriction: 21,
    lineup: ['Disclosure', 'Peggy Gou'],
    categories: ['house', 'party'],
    imageUrl: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=800',
    ticketTypes: [
      { _id: 't4', name: 'Standard', price: 30, quantity: 400, sold: 280, maxPerOrder: 4 },
      { _id: 't5', name: 'VIP Table', price: 150, quantity: 20, sold: 12, maxPerOrder: 2 }
    ],
    lowestPrice: 30,
    analytics: { views: 2800 }
  },
  {
    _id: '3',
    title: 'Bass Culture: DnB All Night',
    slug: 'bass-culture-dnb-all-night',
    description: 'The heaviest drum and bass night in the North. Three rooms, 12 hours of non-stop bass. Featuring the biggest names in the scene.',
    status: 'published',
    venue: {
      name: 'Motion',
      address: '74 Avon Street',
      city: 'Bristol',
      country: 'UK',
      capacity: 2000
    },
    dates: [{ start: new Date(Date.now() + 21 * 24 * 60 * 60 * 1000).toISOString() }],
    ageRestriction: 18,
    lineup: ['Andy C', 'Sub Focus', 'Wilkinson', 'Dimension'],
    categories: ['dnb', 'rave'],
    imageUrl: 'https://images.unsplash.com/photo-1571266028243-e4733b0f0bb0?w=800',
    ticketTypes: [
      { _id: 't6', name: 'First Release', price: 20, quantity: 500, sold: 500, maxPerOrder: 4 },
      { _id: 't7', name: 'Second Release', price: 28, quantity: 800, sold: 650, maxPerOrder: 6 },
      { _id: 't8', name: 'Final Release', price: 35, quantity: 500, sold: 120, maxPerOrder: 4 }
    ],
    lowestPrice: 28,
    analytics: { views: 6200 }
  },
  {
    _id: '4',
    title: 'Disco Inferno',
    slug: 'disco-inferno',
    description: 'Step back in time with classic disco vibes, mirror balls, and funky beats. Dress to impress!',
    status: 'published',
    venue: {
      name: 'Studio 54 Revival',
      address: '12 Glitter Lane',
      city: 'Birmingham',
      country: 'UK',
      capacity: 600
    },
    dates: [{ start: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toISOString() }],
    ageRestriction: 18,
    lineup: ['Horse Meat Disco', 'DJ Paulette'],
    categories: ['disco', 'party'],
    imageUrl: 'https://images.unsplash.com/photo-1545128485-c400e7702796?w=800',
    ticketTypes: [
      { _id: 't9', name: 'General Admission', price: 22, quantity: 500, sold: 200, maxPerOrder: 6 }
    ],
    lowestPrice: 22,
    analytics: { views: 1500 }
  },
  {
    _id: '5',
    title: 'Trance Nation',
    slug: 'trance-nation',
    description: 'A journey through euphoric trance classics and modern anthems. Lasers, fog, and pure energy.',
    status: 'published',
    featured: true,
    venue: {
      name: 'O2 Academy',
      address: 'University Road',
      city: 'Leeds',
      country: 'UK',
      capacity: 2300
    },
    dates: [{ start: new Date(Date.now() + 28 * 24 * 60 * 60 * 1000).toISOString() }],
    ageRestriction: 18,
    lineup: ['Armin van Buuren', 'Above & Beyond', 'Gareth Emery'],
    categories: ['trance', 'rave'],
    imageUrl: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800',
    ticketTypes: [
      { _id: 't10', name: 'Standard', price: 45, quantity: 1800, sold: 900, maxPerOrder: 4 },
      { _id: 't11', name: 'Premium', price: 85, quantity: 300, sold: 150, maxPerOrder: 2 }
    ],
    lowestPrice: 45,
    analytics: { views: 8900 }
  },
  {
    _id: '6',
    title: 'Hip Hop Throwback',
    slug: 'hip-hop-throwback',
    description: '90s and 2000s hip hop classics all night long. Bring your crew and get ready to party like its 1999.',
    status: 'published',
    venue: {
      name: 'The Jazz Cafe',
      address: '5 Parkway',
      city: 'London',
      country: 'UK',
      capacity: 440
    },
    dates: [{ start: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString() }],
    ageRestriction: 18,
    lineup: ['DJ Premier', 'Shortee Blitz'],
    categories: ['hiphop', 'party'],
    imageUrl: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=800',
    ticketTypes: [
      { _id: 't12', name: 'Advance', price: 18, quantity: 350, sold: 290, maxPerOrder: 4 },
      { _id: 't13', name: 'On The Door', price: 25, quantity: 90, sold: 0, maxPerOrder: 2 }
    ],
    lowestPrice: 18,
    analytics: { views: 2100 }
  },
  {
    _id: '7',
    title: 'Sold Out Show',
    slug: 'sold-out-show',
    description: 'This event is completely sold out! Join the waitlist for cancellations.',
    status: 'soldout',
    venue: {
      name: 'Fabric',
      address: '77A Charterhouse St',
      city: 'London',
      country: 'UK',
      capacity: 1600
    },
    dates: [{ start: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString() }],
    ageRestriction: 19,
    lineup: ['Ben Klock', 'Marcel Dettmann'],
    categories: ['techno'],
    imageUrl: 'https://images.unsplash.com/photo-1598387993441-a364f854c3e1?w=800',
    ticketTypes: [
      { _id: 't14', name: 'General Admission', price: 30, quantity: 1600, sold: 1600, maxPerOrder: 4 }
    ],
    lowestPrice: null,
    analytics: { views: 12000 }
  },
  {
    _id: '8',
    title: 'Free Entry: Local Talent Showcase',
    slug: 'free-entry-local-talent',
    description: 'Support local DJs and producers at this free community event. Donations welcome.',
    status: 'published',
    venue: {
      name: 'The Cause',
      address: 'Ashley Road',
      city: 'London',
      country: 'UK',
      capacity: 300
    },
    dates: [{ start: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString() }],
    ageRestriction: 18,
    lineup: ['Various Local Artists'],
    categories: ['house', 'techno'],
    imageUrl: 'https://images.unsplash.com/photo-1508854710579-5cecc3a9ff17?w=800',
    ticketTypes: [
      { _id: 't15', name: 'Free Entry', price: 0, quantity: 300, sold: 180, maxPerOrder: 2 }
    ],
    lowestPrice: 0,
    analytics: { views: 800 }
  },
  {
    _id: '9',
    title: 'Slow Jams & Chill: R&B Night',
    slug: 'slow-jams-rnb-night',
    description: 'An evening dedicated to the smoothest R&B vibes. From classic slow jams to modern hits, this is the perfect night for lovers of soul and rhythm.',
    status: 'published',
    featured: true,
    venue: {
      name: 'XOYO',
      address: '32-37 Cowper Street',
      city: 'London',
      country: 'UK',
      capacity: 800
    },
    dates: [{ start: new Date(Date.now() + 9 * 24 * 60 * 60 * 1000).toISOString() }],
    ageRestriction: 18,
    lineup: ['DJ Spoony', 'Trevor Nelson', 'Rampage'],
    categories: ['rnb', 'party'],
    imageUrl: 'https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=800',
    ticketTypes: [
      { _id: 't16', name: 'Early Bird', price: 15, quantity: 200, sold: 200, maxPerOrder: 4 },
      { _id: 't17', name: 'Standard', price: 22, quantity: 500, sold: 320, maxPerOrder: 6 }
    ],
    lowestPrice: 22,
    analytics: { views: 3200 }
  },
  {
    _id: '10',
    title: 'Pure Garage: UKG Classics',
    slug: 'pure-garage-ukg-classics',
    description: 'Relive the golden era of UK Garage with the original legends. Two-step, speed garage, and all the classics that defined a generation.',
    status: 'published',
    venue: {
      name: 'Ministry of Sound',
      address: '103 Gaunt Street',
      city: 'London',
      country: 'UK',
      capacity: 1600
    },
    dates: [{ start: new Date(Date.now() + 16 * 24 * 60 * 60 * 1000).toISOString() }],
    ageRestriction: 18,
    lineup: ['DJ EZ', 'Heartless Crew', 'Matt Jam Lamont', 'Sticky'],
    categories: ['garage', 'party'],
    imageUrl: 'https://images.unsplash.com/photo-1571935509333-c7d86b8c95c5?w=800',
    ticketTypes: [
      { _id: 't18', name: 'First Release', price: 25, quantity: 400, sold: 400, maxPerOrder: 4 },
      { _id: 't19', name: 'Second Release', price: 32, quantity: 600, sold: 480, maxPerOrder: 4 },
      { _id: 't20', name: 'Final Release', price: 40, quantity: 400, sold: 50, maxPerOrder: 4 }
    ],
    lowestPrice: 32,
    analytics: { views: 5600 }
  },
  {
    _id: '11',
    title: 'Bashment Yard: Reggae & Dancehall',
    slug: 'bashment-yard-reggae-dancehall',
    description: 'The ultimate Caribbean vibes party! Expect the biggest reggae anthems, dancehall bangers, and bashment riddims all night long. Dress to impress!',
    status: 'published',
    venue: {
      name: 'Scala',
      address: '275 Pentonville Road',
      city: 'London',
      country: 'UK',
      capacity: 1150
    },
    dates: [{ start: new Date(Date.now() + 12 * 24 * 60 * 60 * 1000).toISOString() }],
    ageRestriction: 18,
    lineup: ['Seani B', 'Stylo G', 'DJ Nate', 'Selecta Suave'],
    categories: ['reggae', 'party'],
    imageUrl: 'https://images.unsplash.com/photo-1504704911898-68304a7d2807?w=800',
    ticketTypes: [
      { _id: 't21', name: 'Advance', price: 18, quantity: 600, sold: 450, maxPerOrder: 6 },
      { _id: 't22', name: 'VIP', price: 45, quantity: 100, sold: 35, maxPerOrder: 4, description: 'Skip the queue + free drink' }
    ],
    lowestPrice: 18,
    analytics: { views: 4100 }
  }
];

export const mockOrders = [
  {
    _id: 'o1',
    orderNumber: 'TKT-ABC123',
    status: 'confirmed',
    total: 70,
    customerEmail: 'demo@example.com',
    customerName: 'Demo User',
    items: [{ ticketTypeId: 't2', ticketTypeName: 'General Admission', quantity: 2, unitPrice: 35 }],
    event: mockEvents[0],
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    tickets: [
      { _id: 'tk1', ticketCode: 'ABCD1234EFGH', ticketTypeName: 'General Admission', status: 'valid' },
      { _id: 'tk2', ticketCode: 'IJKL5678MNOP', ticketTypeName: 'General Admission', status: 'valid' }
    ]
  }
];

// Helper to get event by slug
export const getEventBySlug = (slug) => {
  return mockEvents.find(e => e.slug === slug) || mockEvents.find(e => e._id === slug);
};
